import { render, staticRenderFns } from "./ToolSelectPreferredObjectStore.vue?vue&type=template&id=1941986b"
import script from "./ToolSelectPreferredObjectStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolSelectPreferredObjectStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports